import React, { Fragment } from "react";
import breakpoint from "styled-components-breakpoint";
import { Cell, Grid } from "react-foundation";
import styled, { ThemeProvider } from "styled-components";
import theme from "../../config/theme";
import Navbar from "../../components/attorney-resource-center/Navbar/Navbar";
import Footer from "../../components/Footer";
import Sidenav from "../../components/attorney-resource-center/Sidenav/Sidenav";
import ArticlesSection from "../../components/attorney-resource-center/ArticlesSection/ArticlesSection";
import SlipOpinionConfirmationPop from "../../components/attorney-resource-center/SlipOpinionConfirmationPop/SlipOpinionConfirmationPop";

const Page = styled.div`
  background-color: ${(props) => props.theme.colors.white};
`;

const Container = styled.div`
  margin-top: 0px;

  ${breakpoint("medium")`
    margin-top: 80px;
  `}
`;

const SidenavContainer = styled.div`
  display: none;

  ${breakpoint("medium")`
    display: block;
  `}
`;

class AttorneyResourceCenterIndex extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      slipConfirmationPopup: this.props.slipConfirmationPopup,
    };
  }

  render() {
    const setShowPop = (state) => {
      this.setState({
        slipConfirmationPopup: state,
      });
    };
    return (
      <Fragment>
        <ThemeProvider theme={theme}>
          <Page>
            <Navbar
              attorneyResourceCenterPath={this.props.attorneyResourceCenterPath}
              caseStudiesPath={this.props.caseStudiesPath}
              fundingAttorneysPath={this.props.fundingAttorneysPath}
              fundingPlaintiffsPath={this.props.fundingPlaintiffsPath}
              fundingGeneralCounselPath={this.props.fundingGeneralCounselPath}
              fundingCasePath={this.props.fundingCasePath}
              rootPath={this.props.rootPath}
              fundingInsightsPath={this.props.fundingInsightsPath}
              regulationsTrendPath={this.props.regulationsTrendPath}
              slipOpinionPath={this.props.slipOpinionPath}
              whitepapersPath={this.props.whitepapersPath}
            />
            <Container>
              <Grid>
                <Cell small={12} medium={4} large={2}>
                  <SidenavContainer>
                    <Sidenav
                      caseStudiesPath={this.props.caseStudiesPath}
                      fundingAttorneysPath={this.props.fundingAttorneysPath}
                      fundingPlaintiffsPath={this.props.fundingPlaintiffsPath}
                      fundingGeneralCounselPath={
                        this.props.fundingGeneralCounselPath
                      }
                      fundingCasePath={this.props.fundingCasePath}
                      rootPath={this.props.rootPath}
                      fundingInsightsPath={this.props.fundingInsightsPath}
                      regulationsTrendPath={this.props.regulationsTrendPath}
                      attorneyResourceCenterPath={
                        this.props.attorneyResourceCenterPath
                      }
                      whitepapersPath={this.props.whitepapersPath}
                    />
                  </SidenavContainer>
                </Cell>
              </Grid>
            </Container>
          </Page>
          {this.state.slipConfirmationPopup && (
            <SlipOpinionConfirmationPop setShowPop={setShowPop} />
          )}
          <Footer bgColor="lighterPurple" />
        </ThemeProvider>
      </Fragment>
    );
  }
}

export default AttorneyResourceCenterIndex;
